<div class="rs-accordion-panel rs-bg-hover rs-bg-tr-b1 jsrs-accordion-panel">
  <a
    href="#"
    role="button"
    class="rs-accordion-title"
    data-accordion-panel-trigger
    [attr.aria-expanded]="expanded"
    [ngClass]="isExpanded ? 'rs-expanded' : ''"
    aria-controls="ac-accordion-content-ip"
    id="ac-accordion-btn-ip"
    [attr.data-cy]="dataCySelector"
  >
    <span class="rs-accordion-title-txt" [attr.data-cy]="dataCyTitle">{{ title }}</span>
    <i class="rs-icon-accordion" [attr.aria-hidden]="!isExpanded"></i>
  </a>
  <div
    class="rs-accordion-content"
    [ngStyle]="isExpanded ? { display: 'block' } : {}"
    [ngClass]="!isExpanded ? 'hide' : ''"
    data-accordion-panel-content
    id="ac-accordion-content-ip"
    aria-labelledby="ac-accordion-btn-ip"
  >
    <div class="row">
      <ng-content></ng-content>
    </div>
  </div>
</div>
